import { FC } from 'react'

import {
  Text,
  GreyGrey80,
  Primary13Regular,
  SimpleModal,
  Flex
} from '@sequencehq/core-components'
import { ModalWithEsignatureProps } from './types'
import { ApprovalFields } from '../ApprovalFields'
import { usePublishBodyCopy } from '../../usePublishBodyCopy'
import { RecipientsSection } from '../RecipientsSection'
import {
  PUBLISH_BUTTON_COPY,
  publishSubmitButtonText,
  publishSubmitData
} from '../publishSubmit'
import {
  MODAL_BASE_PROPS,
  PUBLISH_BODY_TEST_IDS,
  PUBLISH_MODAL_COPY
} from '../PublishQuoteModalV2.constants'

export const ModalRepublish: FC<ModalWithEsignatureProps> = ({
  onSubmit,
  isApprovalRequired,
  message,
  setMessage,
  approvalComment,
  setApprovalComment,
  recipients,
  ...props
}) => {
  const bodyCopy = usePublishBodyCopy()

  return (
    <SimpleModal
      {...MODAL_BASE_PROPS}
      {...props}
      data-testid="modal.publishQuote.republish"
      title={
        isApprovalRequired
          ? PUBLISH_MODAL_COPY.approvalRequired.title
          : PUBLISH_MODAL_COPY.publishChanges.title
      }
      onSubmit={async () => {
        await onSubmit(
          publishSubmitData({
            recipients,
            message,
            approvalComment,
            isApprovalRequired
          })
        )

        return true
      }}
      submitButtonText={publishSubmitButtonText({
        isApprovalRequired,
        recipients,
        copy: PUBLISH_BUTTON_COPY.publishChanges
      })}
      submittingButtonText={
        isApprovalRequired
          ? PUBLISH_MODAL_COPY.approvalRequired.submittingButton
          : PUBLISH_MODAL_COPY.publishQuote.submittingButton
      }
    >
      <Flex gap="16px" flexDir="column">
        <Text
          {...Primary13Regular}
          color={GreyGrey80}
          data-testid={
            isApprovalRequired
              ? PUBLISH_BODY_TEST_IDS.approvalRequired
              : bodyCopy['data-testid']
          }
        >
          {isApprovalRequired
            ? PUBLISH_MODAL_COPY.approvalRequired.body
            : bodyCopy.publishChanges}
        </Text>

        {isApprovalRequired && (
          <ApprovalFields
            data-testid="modal.publishQuote.approvalComment"
            approvalComment={approvalComment}
            setApprovalComment={value => setApprovalComment(value)}
          />
        )}

        <RecipientsSection
          recipients={recipients}
          message={message}
          setMessage={setMessage}
          submitting={props.submitting}
        />
      </Flex>
    </SimpleModal>
  )
}
